// Test.jsx
import React, { Component } from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'
// 引入action
// import { setPageTitle } from '../../store/actions.js'

import HomeTop from "../../components/com_home/homeTop"
// import SollTab from "../../components/com_home/sollTab"
import Articlelist from '../../components/com_home/Articlelist'
import {  runhtml } from '../../tool/runtime'
import RightBox from '../../components/com_all/rightBox'

class Default extends Component {
    componentDidMount(){
        document.title ="Hi 猫宁 ~ |"
    }
    render() {
        return (

            <>
                <section ><HomeTop /></section>
                {/* <section><SollTab /></section> */}
                <div className="homebody">
                <section className="outer row justify-content-center flex-row-reverse">
                    
                    <div className="rightbox">
                        <RightBox className="dark-bg"/>
                    </div>
                    <div className="leftbox">
                    <a className="article-index" ></a>
                    <div className="artcontent" >
                        <Articlelist/>
                    </div>
                    </div>
                    

                </section>
                { runhtml }
                </div>
            </>
        )
    }
}

export default connect()(Default)